import script from "./FirstRegister.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirstRegister.vue?vue&type=script&lang=ts&setup=true"

import "./FirstRegister.vue?vue&type=style&index=0&id=49b6aee2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b6aee2"]])

export default __exports__